import React from 'react';
import { ArrowIcon } from '../icons/ArrowIcon';
import { connect } from 'react-redux';
import { createPureComponent } from 'module/Common';
import { FacebookIcon } from '../icons/FacebookIcon';
import { IconLink, Wrapper } from './ItemSocialLinks.s';
import { InstagramIcon } from '../icons/InstagramIcon';
import { LinkedInIcon } from '../icons/LinkedInIcon';
import { Localized } from 'module/Model/Localized';
import { LocalizedText } from 'module/View/Common';
import { MenuAction } from 'module/Redux/Menu';
import { MenuItemSocialLinks } from 'module/Model/Menu';
import { ReduxCompatibleDispatch } from 'lib/redux-stabilizer';
import { State } from 'module/Redux';

type StateProps = {};

const mapStateToProps = (state: State): StateProps => ({});

type DispatchProps = {
  closeMenu: () => void;
};

const mapDispatchToProps = (dispatch: ReduxCompatibleDispatch): DispatchProps => ({
  closeMenu: () => dispatch(MenuAction.setClose()),
});

type OwnProps = {
  item: MenuItemSocialLinks;
};

type Props = StateProps & DispatchProps & OwnProps;

const ItemSocialLinksComp = createPureComponent<Props>('ItemSocialLinks', ({ item, closeMenu }) => {
  return (
    <Wrapper>
      <LocalizedText content={Localized.create('Suivez-nous', 'Follow us')} />
      <ArrowIcon marginTop={2} />
      <IconLink href={MenuItemSocialLinks.getFacebookLink(item)} target="_blank">
        <FacebookIcon />
      </IconLink>
      <IconLink href={MenuItemSocialLinks.getInstagramLink(item)} target="_blank">
        <InstagramIcon />
      </IconLink>
      <IconLink href={MenuItemSocialLinks.getLinkedInLink(item)} target="_blank">
        <LinkedInIcon />
      </IconLink>
    </Wrapper>
  );
});

export const ItemSocialLinks = connect(mapStateToProps, mapDispatchToProps)(ItemSocialLinksComp);



// WEBPACK FOOTER //
// ./src/module/View/Menu/Items/ItemSocialLinks.tsx